import { inject, Injectable } from '@angular/core';
import { ServiceReminderAnnunciation, ServiceReminder, ServiceIntervals } from '@shared/state';
import { Observable } from 'rxjs';
import { HrtApiService } from '../hrt-api/hrt-api.service';

@Injectable({
  providedIn: 'root',
})
export class ServiceRemindersService {
  readonly url = 'service-reminder';
  readonly api = inject(HrtApiService);

  fetchServiceReminders(): Observable<ServiceReminder[]> {
    return this.api.getForOrganization<ServiceReminder[]>(this.url);
  }

  fetchServiceReminderAnnunciations(annunciationType?: 'SHUTDOWN' | 'WARNING'): Observable<ServiceReminderAnnunciation[]> {
    return this.api.getForOrganization<ServiceReminderAnnunciation[]>(`service-reminders-annunciations?type=${annunciationType}`);
  }

  fetchServiceIntervals(): Observable<ServiceIntervals[]> {
    return this.api.getForOrganization<ServiceIntervals[]>(`machine-service-interval`);
  }

  saveServiceReminderAnnunciations(annunciations: ServiceReminderAnnunciation[]): Observable<ServiceReminderAnnunciation[]> {
    return this.api.postForOrganization<ServiceReminderAnnunciation[]>('service-reminders-annunciations', annunciations);
  }

  saveServiceReminder(serviceReminder: ServiceReminder): Observable<ServiceReminder> {
    return this.api.postForOrganization(this.url, {
      ...serviceReminder,
      machine: undefined,
      totalRunningTime: undefined,
      hoursPerDay: undefined,
      nextReminder: undefined,
      lastModifiedByEmail: undefined,
      lastModifiedAt: undefined,
    });
  }
}
